import { action } from 'typesafe-actions';
import { ServiceDiscoveryInterface, ServiceDiscoveryTypes } from './types';

// List Service Discovery
export const listServiceDiscoveryRequest = (payload: object) =>
  action(ServiceDiscoveryTypes.LIST_SERVICE_DISCOVERY_REQUEST, payload);
export const listServiceDiscoverySuccess = (payload: {
  serviceDiscoveryList: ServiceDiscoveryInterface[];
  totalCount: number;
}) => action(ServiceDiscoveryTypes.LIST_SERVICE_DISCOVERY_SUCCESS, payload);
export const listServiceDiscoveryFailure = () =>
  action(ServiceDiscoveryTypes.LIST_SERVICE_DISCOVERY_FAILURE);

// Update Service Discovery
export const updateServiceDiscoveryRequest = (payload: object) =>
  action(ServiceDiscoveryTypes.UPDATE_SERVICE_DISCOVERY_REQUEST, payload);

export const updateServiceDiscoverySuccess = (payload: {
  serviceDiscoveryData: ServiceDiscoveryInterface;
}) => action(ServiceDiscoveryTypes.UPDATE_SERVICE_DISCOVERY_SUCCESS, payload);

export const updateServiceDiscoveryFailure = () =>
  action(ServiceDiscoveryTypes.UPDATE_SERVICE_DISCOVERY_FAILURE);
